import { Injectable } from "@angular/core";
import { DynamicComponentLoader } from "../../_service/dynamicComponentLoader.service";

@Injectable({ providedIn: "root" })
export class DnDialogService {

    private componentLoaded = {};
    constructor(private _dcl: DynamicComponentLoader) {

    }
    private dialogs: any[] = [];

    // private idToComponent = [{
    //     id:"login-required",
    //     component:import { LoginRequiredComponent } from "../../dialogs/login-required/login-required.component"
    // }]

    add(dialog: any) {
        // console.log(dialog)
        // 添加到队列
        this.dialogs.push(dialog);
        if (!!this.componentLoaded[dialog.id]) {
            this.open(dialog.id, this.componentLoaded[dialog.id].data);
        }
    }

    remove(id: string) {
        // 从队列删除
        this.dialogs = this.dialogs.filter(x => x.id !== id);
    }


    private loadableDialog = [
        {
            key:"login-required-dialog",
            path:"../../_modules/dialog/login-required-dialog.component",
            component:"LoginRequiredDialogComponent"
        }
    ]
    async open(id: string, values = {}) {

        // 打开之前先关闭已打开的对话框
        this.dialogs.filter(x => x.id !== id).map(d => {
            d.close();
        });
        // 打开
        const dialog: any = this.dialogs.filter(x => x.id === id)[0];
        if (!!dialog) {
            if (dialog.visible == undefined || (dialog.visible != undefined && !dialog.visible)) {
                dialog.open(values);
            }
        }
        else {
            if (!this.componentLoaded[id]) {
                let module = await this._dcl.loadModule(import("../../_modules/dialog/dialog.module").then(p=>p.DialogModule));
                this.componentLoaded[id] = {
                    loaded: true,
                    data: values
                };
                switch (id) {
                    case "login-required-dialog":
                        const { LoginRequiredDialogComponent } = await import("../../_modules/dialog/login-required-dialog.component");
                        this._dcl.createComponent(LoginRequiredDialogComponent,module.componentFactoryResolver);
                        break;
                    case "message-dialog":
                        const { MessageDialogComponent } = await import("../../_modules/dialog/message-dialog.component");
                        this._dcl.createComponent(MessageDialogComponent,module.componentFactoryResolver);
                        break;
                    case "confirm-dialog":
                        const { ConfirmDialogComponent } = await import("../../_modules/dialog/confirm-dialog.component");
                        this._dcl.createComponent(ConfirmDialogComponent,module.componentFactoryResolver);
                        break;
                    // case "payment-confirm-dialog":
                    //     const { PaymentConfirmDialogComponent } = await import("../../_modules/dialog/payment-confirm-dialog.component");
                    //     this._dcl.createComponent(PaymentConfirmDialogComponent,module.componentFactoryResolver);
                    //     break;
                    case "custom-iframe-dialog":
                        const { CustomIframeDialogComponent } = await import("../../_modules/dialog/custom-iframe-dialog.component");
                        this._dcl.createComponent(CustomIframeDialogComponent,module.componentFactoryResolver);
                        break;
                    case "prevent-dialog":
                        const { PreventDialogComponent } = await import("../../_modules/dialog/prevent-dialog.component");
                        this._dcl.createComponent(PreventDialogComponent,module.componentFactoryResolver);
                        break;

                    case "daily-sign-in-dialog":
                        const { DailySignInDialogComponent } = await import("../../_modules/dialog/daily-sign-in-dialog.component");
                        this._dcl.createComponent(DailySignInDialogComponent,module.componentFactoryResolver);
                        break;

                    case "teaser-detail-dialog":
                        const { TeaserDetailDialogComponent } = await import("../../_modules/dialog/teaser-detail-dialog/teaser-detail-dialog.component");
                        this._dcl.createComponent(TeaserDetailDialogComponent,module.componentFactoryResolver);
                        break;

                    case "notForself-dialog":
                        const { NotForselfDialogComponent } = await import("../../_modules/dialog/not-forself-dialog.component");
                        this._dcl.createComponent(NotForselfDialogComponent,module.componentFactoryResolver);
                        break;

                    case "ask-leave-dialog":
                        const { AskLeaveDialogComponent } = await import("../../_modules/dialog/ask-leave-dialog.component");
                        this._dcl.createComponent(AskLeaveDialogComponent,module.componentFactoryResolver);
                        break;
                    case "not-allow-video-download-dialog":
                        const { NotAllowVideoDownloadDialogComponent } = await import("../../_modules/dialog/not-allow-video-download-dialog.component");
                        this._dcl.createComponent(NotAllowVideoDownloadDialogComponent,module.componentFactoryResolver);
                        break;

                    case "4k-ask-app-download-dialog":
                        const { AskAppDownloadDialogComponent } = await import("../dialog/ask-app-download-dialog.component");
                        this._dcl.createComponent(AskAppDownloadDialogComponent,module.componentFactoryResolver);
                        break;
                    case "not-allow-daily-sign-in-dialog":
                        const { NotAllowDailySignInDialogComponent } = await import("../../_modules/dialog/not-allow-daily-sign-in-dialog.component");
                        this._dcl.createComponent(NotAllowDailySignInDialogComponent,module.componentFactoryResolver);
                        break;
                    case "report-in-play-page-dialog":
                        const { ReportInPlayPageDialogComponent } = await import("../../_modules/dialog/report-in-play-page-dialog.component");
                        this._dcl.createComponent(ReportInPlayPageDialogComponent,module.componentFactoryResolver);
                        break;
                    case "ask-bind-tel-dialog":
                        const { AskBindTelDialogComponent } = await import("../../_modules/dialog/ask-bind-tel-dialog.component");
                        this._dcl.createComponent(AskBindTelDialogComponent,module.componentFactoryResolver);
                        break;
                    case "ask-giveup-bargain-dialog":
                        const { AskGiveupBargainDialogComponent } = await import("../../_modules/dialog/ask-giveup-bargain-dialog.component");
                        this._dcl.createComponent(AskGiveupBargainDialogComponent,module.componentFactoryResolver);
                        break;
                }
            }


            //this.open(id,values);
        }

    }


    close(id: string, force = true) {
        // 关闭
        const modal: any = this.dialogs.filter(x => x.id === id)[0];
        if (modal) {
            modal.close(force);
        }
    }
}
